export default function MsalErrorExecption(e: any) {
    const { error } = e;
  
    if (error) {
      const { errorMessage } = error;
      if (error.errorCode === "no_cached_authority_error") {
        window.location.reload();
      } else if (String(errorMessage).includes("AADB2C90091")) {
        window.location.reload();
      }
    }
  
    return <span>Loading</span>;
  }